export const undoHistory = (params) => {
  const { history: currentHistory } = params;
  if (!currentHistory.tail.prev) {
    return { history: null };
  }
  let { tail } = currentHistory;
  const temp = tail;
  tail = tail.prev;
  tail.next = temp;
  const history = {
    ...currentHistory,
    tail: {
      ...currentHistory.tail,
      ...tail,
    },
  };

  return { history };
};

export const redoHistory = (params) => {
  const { history: currentHistory } = params;
  if (!currentHistory.tail.next) {
    return { history: null };
  }
  let { tail } = currentHistory;
  const temp = tail;
  tail = tail.next;
  tail.prev = temp;
  const history = {
    ...currentHistory,
    tail: {
      ...currentHistory.tail,
      ...tail,
    },
  };

  return { history };
};
